import { dutchAmounts } from "./dutch-amount.service";

export class winDutchService {
  constructor() {}

  getWinDutchData(
    dutch: any,
    legs: any[][],
    userInput: number,
    selectedEvent: any,
    matrix: any,
    eventsArray?: any,
    eventIdFocus?: number | any,
    raceFocus?: number | any,
    // EventFindRace: (races: any[], focus: number) => any,
    // getMatrixInCache: (poolId: any) => any
  ): Record<string, any> | undefined {
    const runners: any[] = [];
    const max = legs.length - 1;

    // const event = eventsArray[eventIdFocus];
    // const pool = EventFindRace(event.Races, raceFocus)?.Pools[0];
    const pool = selectedEvent.ToteResponse.EventDetail.currentRace?.Pools[0];

    if (pool) {
      // const matrix = getMatrixInCache(pool.PoolId);
      // const matrix = this.poolMatrix[this.selectedPool?.PoolId]?.response?.ToteResponse;

      if (legs.length === pool.Legs * pool.PoolRaces) {
        const helper = (arr: any[], i: number): void => {
          for (let j = 0, l = legs[i].length; j < l; j++) {
            const a = [...arr]; // clone array
            a.push(legs[i][j]);

            if (i === max) {
              if (pool.Legs > 1) {
                if (a[0] !== a[1]) {
                  runners.push(a);
                }
              } else {
                runners.push(a);
              }
            } else {
              helper(a, i + 1);
            }
          }
        };

        helper([], 0);
      }

      const dutchHolder = new dutchAmounts(runners, pool, userInput);

      dutchHolder.initBaseParams(matrix);
      const dutchAmountHolder = dutchHolder.calcAmountByBaseAmount(userInput, matrix);
      // const dutchAmountHolder =
      //   dutch === 1
      //     ? dutchHolder.calcAmountByBaseAmount(userInput, matrix)
      //     : dutchHolder.calcAmountByBasePayout(userInput, matrix);

      const runnersWithStake: Record<string, any> = {};
      for (let i = 0; i < runners.length; i++) {
        runnersWithStake[runners[i][0]] = dutchAmountHolder[i];
      }

      return runnersWithStake;
    }
    return undefined;
  }

}
